import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
    filtro: {
        data_inicial: DateFormat.getDataAnterior(7),
        data_final: DateFormat.getDataAtual()
    },
	aguardando: false,
	lista: [],
    listaHistorico: [],
    listaItens: [],
    listaCliente: [],
    listaFormaPagamento: [],
    listaTipoPagamento: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PEDIDO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PEDIDO_SET_FILTRO':
			return { ...state,
				filtro: action.payload
			};

		case 'PEDIDO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PEDIDO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data
            };

        case 'PEDIDO_HISTORICO_LISTADO':
            return {
                ...state, 
                listaHistorico: action.payload.data
            };
        
        case 'PEDIDO_ITEM_LISTADO':
            return {
                ...state, 
                listaItens: action.payload.data
            };

        case 'PEDIDO_FORMA_PAGAMENTO_LISTADO':            
            return {
                ...state, 
                listaFormaPagamento: action.payload.data
            };

        case 'PEDIDO_TIPO_PAGAMENTO_LISTADO':
            return {
                ...state, 
                listaTipoPagamento: action.payload.data
            };

        default:
            return state;
    }
}
